<template>
  <div class="adminLogin">
    <div style="width: 400px;background: #fff;padding: 0 50px;margin-right: 30px;padding-bottom: 15px;">
      <el-form :model="loginForm" :rules="rules" ref="ruleForm">
        <el-form-item style="margin: 0;text-align: center;">
          <p style="margin: 15px 0;font-weight: bold;font-size: 18px;">登录高毅问卷系统</p>
        </el-form-item>
        <el-form-item prop="name">
          <el-input v-model="loginForm.name" placeholder="账户"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item style="text-align: center;">
          <el-button style="width: 150px;" @click="login">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {userLogin} from '@/service/adminApis'
import lodash from "lodash";
import { ADEncrypt, localCache } from '@gyasset/shared/utils';
import { env } from '@/common/host';

export default {
  name: "adminLogin",
  data() {
    return {
      AD: null,
      loginForm: {
        name: "",
        password: "",
      },
      rules: {
        name: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ]
      }
    }
  },
  mounted() {
    const envADE = env.ADEncrypt || {};
    this.AD = new ADEncrypt(envADE.env, envADE.appCode, envADE.appValue);
  },
  methods: {
    login: lodash.debounce(async function () {
      let {name, password} = this.loginForm
      if (!name) {
        return this.$message.error("用户名不能为空")
      }
      if (!password) {
        return this.$message.error("密码不能为空")
      }
      try {
        const { userName, token } = await this.AD.login(name, password);
        localCache.set('token', token);
        this.$router.push(({name: 'clientInformationForm'}))
      } catch(res) {
        this.$message.error(res.message || '账号错误')
      }
      // const ADpassword = await this.AD.getEncryptPd(password)
      // let res = await userLogin(name, ADpassword)
      // if (res) {
      //   let {code, msg} = res
      //   if (code === '0') {
      //     this.$router.push(({name: 'clientInformationForm'}))
      //   } else {
      //     this.$message.error(msg || "服务异常，请联系客服")
      //   }
      // }
    }, 200)
  }
}
</script>

<style lang="less">
.adminLogin {
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  background: url("../../assets/banner.jpg");
  background-size: cover;
  overflow: hidden;
  display: flex;
  justify-content: right;
  align-items: center;
}
</style>
